






import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component({
    components: {},
    props: {
        message: {
            type: Object,
            required: true
        }
    }
})

export default class ChatImportantMessage extends Vue {
    /** Дополнительное преобразование nl2br в тексте */
    private getMessageText(text:string): string
    {
        return (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1<br>$2`);
    }
}
